import React from 'react'
import useImport from '../../import'
import InfoNote from '../../InfoNote'

const FORCE_DISABLED = false

const resultMap = {
  entities: false,
  updated: 'variants updated',
  created: false,
  deleted: false,
  validated: false,
}

const VariantsImport = () => {
  const { FileSelector, FileImport, result, fileSelected, disabled } =
    useImport({
      event: 'Variants import',
      method: 'variants/import',
      resultMap,
    })

  return (
    <>
      {!result?.runId && !fileSelected && (
        <>
          <FileSelector disabled={disabled || FORCE_DISABLED} launched={true} />
        </>
      )}

      {(result?.runId || fileSelected) && <FileImport />}

      <div className="rounded-md opacity-30 mt-auto pt-4">
        <InfoNote title="Have a backup?">
          Make sure you have a{' '}
          <span className="font-bold">recent, unmodified CSV file</span> in case
          you need to restore your data.{' '}
        </InfoNote>
        <InfoNote title="Read-only columns">
          The all uppercase columns will contain read-only values. You can't
          change these values upon import with this tool.
        </InfoNote>
      </div>
    </>
  )
}

export default VariantsImport
